import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-Contacts',
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})

export class ContactComponent {
  contactDetails: any;
  contact1Label: string = "";
  contact2Label: string = "";
  contact1Value: string = "";
  contact2Value: string = "";
  userGuideUrl: string = "";
  userGPID: string | null;
  systemId: string | null;
  isContactAvailable: boolean = false;

  constructor(
    private readonly commonService: CommonService, 
    private readonly dialogRef: MatDialogRef<ContactComponent>
  ) {
    this.userGPID = localStorage.getItem("userGPID");
    this.systemId = localStorage.getItem('SelectedSystemId');
  }

  ngOnInit(): void {
    this.getContact();
  }
  
  getContact(): void {
    this.commonService.getContact().subscribe({
      next: (data) => {
        this.isContactAvailable = true;
        this.contactDetails = data;
        this.contact1Label = this.contactDetails[1].split(':')[0];
        this.contact2Label = this.contactDetails[2].split(':')[0];
        this.contact1Value = this.contactDetails[1].split(':')[1];
        this.contact2Value = this.contactDetails[2].split(':')[1];
      },
      error: () => {
        this.isContactAvailable = false;
      }
    });
  }

  cancel(): void {
    this.dialogRef.close('cancel');
  }
}